import React from 'react';
import {useThemeContext} from '@crema/context/AppContextProvider/ThemeContextProvider';
import {Box} from '@mui/material';
import {ReactComponent as Logo} from '../../../../../assets/icon/equine_logo.svg';
import {useNavigate} from 'react-router-dom';
// import {ReactComponent as LogoText} from '../../../../../assets/icon/logo_text.svg';

type AppLogoProps = {
  color?: string;
};

const AppLogo: React.FC<AppLogoProps> = ({color}) => {
  const navigate = useNavigate();
  const {theme} = useThemeContext();

  return (
    <Box
      sx={{
        // width: {xs: '300px', sm: '350px', md: '400px'}, // box width controls logo size
        width: 'auto',
        height: 'auto', // let height adjust naturally
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': {
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          display: 'flex',
        },
      }}
      className='app-logo'
      onClick={() => navigate('/Home')}
    >
      <Logo fill={theme.palette.primary.main} />
      <Box
        sx={{
          mt: 1,
          display: {xs: 'none', md: 'block'},
          '& svg': {
            height: {xs: 25, sm: 30},
          },
        }}
      >
        {/* <LogoText fill={alpha(theme.palette.text.primary, 0.8)} /> */}
      </Box>
    </Box>
  );
};

export default AppLogo;
